import { useMemo } from 'react';
import type { FiltresJournal, TakiSdk } from '@taki/sdk';
import type { JournalPort } from '@taki/ui';

/**
 * Le port du journal d'audit, branche sur `sdk.journal` (`docs/JOURNAL.md`).
 * `null` pour qui n'est pas proprietaire : l'ecran dit alors qu'il est reserve,
 * sans meme poser la question aux rules, qui la refuseraient.
 */
export function useJournalDeLHote(sdk: TakiSdk, proprietaire: boolean): JournalPort | null {
  return useMemo(() => (proprietaire ? { lister: (filtres) => sdk.journal.list(filtres as FiltresJournal) } : null), [sdk, proprietaire]);
}
